import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../components/Modal/Modal';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
//Api
import destinacaoColeta_api from '../../api/destinacaoColeta_api';
//Helpers
import mascaras from '../../helpers/mascaras';
import { showMessage } from '../../helpers/message';
import { transformValueFloattoFormated } from '../../helpers/formats';
import { validarCampos, objCampo } from '../../helpers/ValidadorDeCampos';
import uuid from '../../helpers/guid';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Estado inicial para a ordem a ser baixada
function initialState() {
    return {
        veiculo: "",
        tbOrdemColeta_Id: 0,
        tbDestinosEntradaAvulsa_Id: 0,
        pesoEntrada: "",
        pesoSaida: "",
        observacao: "",
        origem: "",
        anexos: [],
    }
}
export default function SaidaResiduos() {

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle de exibição do modal de confirmar saida na tela
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle da ordem a ser confirmada a saida ou recusada
    const [ordemBaixa, setOrdemBaixa] = useState(initialState);

    //Estado de controle do modal de recusa na tela
    const [openModalRecusa, setOpenModalRecusa] = useState(false);

    //Troca o estado do modal de recusa na tela
    const toggleModalRecusa = (item) => {
        if (!openModalRecusa) {
            const _ordemBaixa = initialState();
            _ordemBaixa.tbOrdemColeta_Id = item.tbOrdemColeta_Id;
            _ordemBaixa.pesoEntrada = item.pesoEntrada;
            _ordemBaixa.pesoSaida = "0,00";
            _ordemBaixa.veiculo = item.veiculo;
            _ordemBaixa.observacao = "";
            setOrdemBaixa(_ordemBaixa);
        } else {
            setOrdemBaixa(initialState);
        }
        setOpenModalRecusa(!openModalRecusa)
    };

    //Estado de controle para edição do peso de entrada na saida
    const [activePesoEntrada, setActivePesoEntrada] = useState(true);

    //Estado que armazena os campos que possuem erros
    const [errors, setErrors] = useState({});

    //Campos obrigatorios para a recusa
    const camposRecusa = [
        objCampo({ name: "observacao", required: true })
    ]

    //Controle de edição do peso de entrada na saida
    const togglePesoEntrada = () => {
        setActivePesoEntrada(!activePesoEntrada);
    };

    //OnChange para os campos dos modais
    const onChangeOrdemBaixa = (e) => {
        const { name, value } = e.target;
        setOrdemBaixa({
            ...ordemBaixa,
            [name]: value
        })
    }

    //OnChange para os anexos da recusa da saida
    const onChangeAnexo = (e) => {
        const anexo = { nome: "", base64: "" };
        anexo.nomeArquivo = e.target.files[0].name;
        anexo.nome = e.target.files[0].name;
        const FR = new FileReader();
        FR.addEventListener("load", function (evt) {
            anexo.base64 = evt.target.result.split("base64,")[1];
            anexo.nome = anexo.nome.split(".");
            anexo.nome = uuid() + "." + anexo.nome[anexo.nome.length - 1];
            setOrdemBaixa({
                ...ordemBaixa,
                anexos: [...ordemBaixa.anexos, anexo]
            });

        });
        FR.readAsDataURL(e.target.files[0]);
    }

    //Remove um dos anexos que foram adicionados
    const removerAnexo = (index) => {
        const _ordemBaixa = {
            ...ordemBaixa
        }
        _ordemBaixa.anexos.splice(index, 1);
        setOrdemBaixa(_ordemBaixa);
    }

    //Troca o estado de exibição do modal de confirmação de saida
    const toggleModal = () => setOpenModal(!openModal);

    //Cabeçalhos  da tabela de entrada de residuos
    const headersTabela = [
        { value: "Data", objectValue: "dataColeta" },
        { value: "Veiculo", objectValue: "veiculo" },
        { value: "Modalidade de coleta", objectValue: "modalidadeColeta" },
        { value: "Transportador", objectValue: "transportador" },
        { value: "Peso de entrada", objectValue: "pesoEntrada" },
    ]

    //Ordens que serão exibidas na listagem
    const [ordens, setOrdens] = useState([]);

    //Configura os dados dos campos para enviar para atualização da saida
    const confirmarRecebimento = (item, itemKey) => {
        const _ordemBaixa = initialState();
        _ordemBaixa.tbOrdemColeta_Id = item.tbOrdemColeta_Id;
        _ordemBaixa.tbDestinosEntradaAvulsa_Id = item.tbDestinosEntradaAvulsa_Id;
        _ordemBaixa.pesoEntrada = item.pesoEntrada;
        _ordemBaixa.pesoSaida = "0,00";
        _ordemBaixa.veiculo = item.veiculo;
        _ordemBaixa.observacao = "";
        _ordemBaixa.origem = item.origem;
        setOrdemBaixa(_ordemBaixa);
        toggleModal();
    }

    //Submete os dados atualizados para a rota de saida
    const AtualizarDadosOrdemBaixa = () => {
        const _ordemBaixa = { ...ordemBaixa };
        _ordemBaixa.pesoEntrada = parseFloat(_ordemBaixa.pesoEntrada.replace(",", "."));
        _ordemBaixa.pesoSaida = parseFloat(_ordemBaixa.pesoSaida.replace(",", "."));
        if (isNaN(_ordemBaixa.pesoEntrada) || isNaN(_ordemBaixa.pesoSaida)) {
            showMessage("Aviso", "O peso de entrada/saida deve ser do tipo numerico", "info", null);
            return;
        } else if (_ordemBaixa.pesoEntrada < _ordemBaixa.pesoSaida) {
            showMessage("Aviso", "O peso de saida não pode ser maior do que o peso de entrada", "info", null);
            return;
        }
        setLoading(true);

        destinacaoColeta_api.AtualizarDestinacao("Saida", _ordemBaixa).then(response => {
            showMessage("Sucesso", "Saida confirmada com sucesso!", "success", loadOrdens);
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega as ordens pendentes de saida
    const loadOrdens = () => {
        setLoading(true);
        destinacaoColeta_api.GetList("Saida").then(response => {
            response.data = response.data.map(value => {
                value.dataColeta = moment(value.dataColeta).format("DD/MM/YYYY");
                value.pesoEntrada = transformValueFloattoFormated(value.pesoEntrada, 2);
                return value;
            })
            setOrdens(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Recusa a ordem escolhida
    const recusaOrdem = () => {
        const _errors = validarCampos(ordemBaixa, camposRecusa);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);
        destinacaoColeta_api.RecusaOrdem(ordemBaixa).then(response => {
            showMessage("Sucesso", "Saída recusada com sucesso!", "success", loadOrdens);
            toggleModalRecusa();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false))
    }

    const recusaSaidaBtn = (rowData, actionStyle) => {
        //Controle das saidas que podem ser removidas

    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.confirmar(confirmarRecebimento),
        (rowData) => {
            if (rowData.tbOrdemColeta_Id !== 0) {
                return actionsTable.remover(toggleModalRecusa);
            } else {
                return null;
            }
        }
    ]
    //Carrega a lista de ordens disponiveis para confirmação ou recusa
    useEffect(() => {
        loadOrdens();
    }, []);

    return (
        <MainCard noCard>
            {loading && <Loading />}
            <ModalCustomized title={"Confirmação de saída de veículo"} isOpen={openModal} toggle={toggleModal} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar</>} btnActionColor={"success"} className={"modalCustomized"} onClickBtnAction={AtualizarDadosOrdemBaixa} btnClose>
                <Row>
                    <Col md="12" lg="6">
                        <TextField label={"Veículo"} value={ordemBaixa && ordemBaixa.veiculo} disabled />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField mask={mascaras.floatMask} icon={faEdit} onClickIcon={togglePesoEntrada} label={"Peso de entrada (KG)"} disabled={activePesoEntrada} name="pesoEntrada" value={ordemBaixa && ordemBaixa.pesoEntrada} onChange={onChangeOrdemBaixa} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField mask={mascaras.floatMask} label={"Peso de saída (KG)"} name={"pesoSaida"} value={ordemBaixa && ordemBaixa.pesoSaida} onChange={onChangeOrdemBaixa} invalid={
                            parseFloat(ordemBaixa.pesoSaida.replace(",", ".")) == 0
                                || parseFloat(ordemBaixa.pesoSaida.replace(",", ".")) > parseFloat(ordemBaixa.pesoEntrada.replace(",", ".")) ? true : false} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label={"Peso descarregado (KG)"} disabled value={ordemBaixa && ordemBaixa.pesoSaida !== "" ? (parseFloat(ordemBaixa.pesoEntrada.replace(",", ".")) - parseFloat(ordemBaixa.pesoSaida.replace(",", "."))).toFixed(2).toString().replace(".", ",") : ""} />
                    </Col>
                </Row>
            </ModalCustomized>
            <ModalCustomized title={"Recusa de saída de veículo"} isOpen={openModalRecusa} toggle={toggleModalRecusa} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar recusa</>} btnActionColor={"success"} onClickBtnAction={recusaOrdem} btnClose>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label={"* Justificativa da recusa"} type="textarea" name={"observacao"} onChange={onChangeOrdemBaixa} value={ordemBaixa.observacao} invalid={!!errors.observacao} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label={"Anexos"} type="file" name="anexos" onChange={onChangeAnexo} />
                    </Col>
                </Row>
                <Row>
                    {ordemBaixa.anexos.map((value, index) => {
                        return (
                            <Col md="6" lg="2" className='mt-4'>
                                <div className='border text-secondary p-2 shadow d-flex flex-column align-items-center justify-content-center rounded-3 position-relative'>
                                    <button color='danger' className="cancelFileButton" onClick={() => removerAnexo(index)}>
                                        X
                                    </button>
                                    <FontAwesomeIcon size='4x' icon={faFileAlt} />
                                    <p className='m-0 mt-2 fw-bold'>{value.nomeArquivo}</p>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
            </ModalCustomized>
            <TabelaListagem actions={actions} title={"Receber Resíduos - Saída"} options={{ print: false, search: true, pagination: true }} headers={headersTabela} items={ordens} />
        </MainCard>
    )
}